// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__nxWIR","amount":"Amount_amount__2_HWN","tip":"Amount_tip__3xP2G","tipHeader":"Amount_tipHeader__X0_QS","tipsWrap":"Amount_tipsWrap__2brsX"};